import { Button, Description, Field, Input, Label } from "@kalkulacka-one/design-system/client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { type SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";

import { subscribe } from "@/server/subscribe";

const subscribeSchema = z.object({
  email: z.string().email("Neplatný formát"),
});

type SubscribeData = z.infer<typeof subscribeSchema>;

export function SubscribeForm({ origin = "subscribe-form" }: { origin?: string }) {
  const [isSuccessfullySubmitted, setIsSuccessfullySubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setError,
    setFocus,
    formState: { errors, isSubmitting },
  } = useForm<SubscribeData>({
    resolver: zodResolver(subscribeSchema),
  });

  const onSubmit: SubmitHandler<SubscribeData> = async (data) => {
    setIsSuccessfullySubmitted(false);
    try {
      const response = await subscribe({ ...data, origin });
      if (response.success) {
        reset();
        setIsSuccessfullySubmitted(true);
      } else {
        setError("root.serverError", {
          message: response.error,
        });
        setFocus("email");
      }
    } catch (_error) {
      setError("root.serverError", {
        message: "Chyba pri pripojení k serveru. Skúste to prosím neskôr.",
      });
      setFocus("email");
    }
  };

  return (
    <>
      {isSuccessfullySubmitted ? (
        <div>Ďakujeme za vyplnenie</div>
      ) : (
        <form className="flex flex-col gap-4 items-center" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Field disabled={isSubmitting}>
            <div className="grid gap-3 justify-center">
              <div className="flex gap-3 justify-center items-center">
                <Label className="sr-only">Zadajte váš e-mail</Label>
                <Input invalid={!!errors.email} autoComplete="email" type="email" placeholder="E-mail" {...register("email")} />
                <Button disabled={isSubmitting} type="submit" variant="outline" color="neutral">
                  {isSubmitting ? "Odosielam" : "Odoslať"}
                </Button>
              </div>
              <div className="text-center space-y-1">
                {errors.email && <Description className="text-xs text-[var(--ko-palette-secondary)]">{errors.email.message}</Description>}
                {errors.root?.serverError && <Description className="text-sm">⚠️ {errors.root?.serverError.message}</Description>}
                <p className="text-xs text-slate-500">Odoslaním súhlasíte so zasielaním noviniek o volebnej kalkulačke.</p>
              </div>
            </div>
          </Field>
        </form>
      )}
    </>
  );
}
